module.exports = __webpack_public_path__ + "static/media/maf-35.84f8e565.png";